import React from 'react';
import './chat.css';

const formatDayLabel = (date) => {
    if (!date) return '';
    const now = new Date();
    if (date.toDateString() === now.toDateString()) return 'Today';
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    if (date.toDateString() === yesterday.toDateString()) return 'Yesterday';
    return date.toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric' });
};

const DaySeparator = ({ date }) => (
    <div className="wt-day-separator" role="separator">
        <span className="wt-day-separator-line" />
        <span className="wt-day-separator-label">{formatDayLabel(date)}</span>
        <span className="wt-day-separator-line" />
    </div>
);

export default DaySeparator;
